import { Button } from '@/components/ui/button'
import { INSPECTION_COLORS } from '@/constants/inspection-colors'
import { cn } from '@/lib/utils'
import type { InspectionType } from '@/types'

const HOVER_BY_TYPE: Record<InspectionType, string> = {
	'yellow-card': 'hover:bg-kaefer-sunny-yellow/90 hover:text-kaefer-dark-grey',
	directed: 'hover:bg-kaefer-ocean-blue/90 hover:text-gray-100',
	'see-act': 'hover:bg-kaefer-grass-green/90 hover:text-gray-100',
	interaction: 'hover:bg-kaefer-violet/90 hover:text-gray-100',
}

const ACTIVE_BY_TYPE: Record<InspectionType, string> = {
	'yellow-card': INSPECTION_COLORS.sunnyYellow.optionActive,
	directed: INSPECTION_COLORS.oceanBlue.optionActive,
	'see-act': INSPECTION_COLORS.grassGreen.optionActive,
	interaction: INSPECTION_COLORS.violet.optionActive,
}

const BADGE_SELECTED_BY_TYPE: Record<InspectionType, string> = {
	'yellow-card': 'bg-kaefer-dark-grey/10 text-kaefer-dark-grey',
	directed: 'bg-white/20 text-white',
	'see-act': 'bg-white/20 text-white',
	interaction: 'bg-white/20 text-white',
}

const BADGE_HOVER_BY_TYPE: Record<InspectionType, string> = {
	'yellow-card':
		'group-hover:bg-kaefer-sunny-yellow/90 group-hover:text-kaefer-dark-grey',
	directed: 'group-hover:bg-kaefer-ocean-blue/90 group-hover:text-white',
	'see-act': 'group-hover:bg-kaefer-grass-green/90 group-hover:text-white',
	interaction: 'group-hover:bg-kaefer-violet/90 group-hover:text-white',
}

type InspectionTypeButtonProps = {
	type: InspectionType
	label: string
	count: number
	selected: boolean
	onClick: () => void
}

export const InspectionTypeButton = ({
	type,
	label,
	count,
	selected,
	onClick,
}: InspectionTypeButtonProps) => {
	const activeClassName = ACTIVE_BY_TYPE[type]
	const hoverClassName = HOVER_BY_TYPE[type]
	const badgeClassName = selected
		? BADGE_SELECTED_BY_TYPE[type]
		: cn(
				'bg-kaefer-light-silver/80 text-kaefer-dark-grey',
				BADGE_HOVER_BY_TYPE[type],
			)

	return (
		<Button
			variant={selected ? 'default' : 'outline'}
			size="sm"
			onClick={onClick}
			className={cn(
				'group w-full gap-2 lg:flex-1',
				selected
					? activeClassName
					: cn(
							'border-kaefer-light-silver bg-white text-kaefer-dark-grey',
							hoverClassName,
						),
			)}
		>
			{label}
			<span
				className={cn(
					'rounded-full px-2 py-0.5 text-xs font-medium transition-colors',
					badgeClassName,
				)}
			>
				{count}
			</span>
		</Button>
	)
}
